module.exports = __webpack_public_path__ + "img/circle-menu.7688acd2.svg";